import { BASE_COLORS, BORDER_RADIUS } from '@app/style/constants';

const antdGlobalStyles = {
	borderRadius: parseInt(BORDER_RADIUS.match(/\d+/)?.[0] || '0', 10),
	colorBgLayout: BASE_COLORS.white,
	colorLink: BASE_COLORS.blue,
	colorPrimary: BASE_COLORS.green,
	fontFamily: '"Inter", serif',
	controlHeight: 34,
	fontSize: 14,
	Alert: {
		paddingVertical: 0,
		withDescriptionPadding: '8px 16px',
		colorSuccessBorder: 'transparent',
	}
};

export default antdGlobalStyles;
